import React from 'react';
import GoogleMapComponent from '../../GoogleMapComponent'; // Assuming this is your custom component
import StarRating from '../../GoogleMapComponent/RatingComponent'; // Assuming you have a star rating component

function GooglePlacesNearMe({
  relatedPlacesNearMe,
  placesNearMe,
  isAddressType,
  isPlaceNearToggled,
  expandOpenHours,
  handleToggleOpenHours,
  openLinkInNewTab,
  copyPhoneNumber,
  handleOpenGoogleMaps,
  DPPstate,
}) {
  const getAllMapCoordinates = relatedPlacesNearMe?.map((vl) => {
    let lat = 0;
    let lng = 0;
    if (vl.geometry?.location) {
      if (typeof vl.geometry.location.lat === 'function' && typeof vl.geometry.location.lng === 'function') {
        lat = vl.geometry.location.lat();
        lng = vl.geometry.location.lng();
      } else if (typeof vl.geometry.location.lat === 'number' && typeof vl.geometry.location.lng === 'number') {
        lat = vl.geometry.location.lat;
        lng = vl.geometry.location.lng;
      }
    }
    return { lat, lng, name: vl.name };
  });

  return (
    <div id={`google-place-${placesNearMe}`} className={isPlaceNearToggled ? 'google-map-control d-block' : 'google-map-control d-none'}>
      <div className={`location-details ${isAddressType === 'nearPlaces' ? 'google-place-details' : 'google-address'}`}>
        {DPPstate?.publishHtml ? (
          <GoogleMapComponent withMultiCoordinates lat={0} lng={0} locations={getAllMapCoordinates} showMapImage />
        ) : (
          <GoogleMapComponent
            withMultiCoordinates
            lat={0}
            lng={0}
            locations={getAllMapCoordinates}
            // showMapImage
          />
        )}
        {relatedPlacesNearMe?.map((vl, i) => {
          const currLatLng = getAllMapCoordinates[i];
          return (
            <div className="mt-2" key={i}>
              <div className="map-location-title">
                {vl?.name}
                <div className="icons-data">
                  {vl.website && (
                    <button aria-label="btn" type="button" onClick={() => openLinkInNewTab(vl.website)}>
                      <span className="icon-Website-detail" />
                    </button>
                  )}
                  {vl.formatted_phone_number && (
                    <button aria-label="btn" type="button" onClick={() => copyPhoneNumber(vl.formatted_phone_number)}>
                      <span className="icon-Call-detail" />
                    </button>
                  )}
                  {currLatLng?.lat && currLatLng?.lng && (
                    <button aria-label="btn" type="button" onClick={() => handleOpenGoogleMaps({ lat: currLatLng.lat, lng: currLatLng.lng })}>
                      <span className="icon-Navigation-detail" />
                    </button>
                  )}
                </div>
              </div>
              {vl?.formatted_address && <p className="location-address">{vl?.formatted_address}</p>}
              {vl?.rating && (
                <div className="location-rating" style={{ display: 'flex' }}>
                  {`(${vl?.rating})`}
                  <span style={{ marginRight: '5px' }}>
                    <StarRating rating={vl?.rating} />
                  </span>
                </div>
              )}
              <div className="d-flex align-items-center other-detail">
                <p>{vl?.opening_hours?.open_now ? <span className="location-open">Open</span> : <span className="location-close">Close</span>}</p>
                {vl?.formatted_phone_number && <p className="ml-auto">{vl?.formatted_phone_number || 'N/A'}</p>}
              </div>
              {vl?.opening_hours && vl?.opening_hours?.weekday_text?.length > 0 && (
                <div>
                  <div>
                    <strong>Opening Hours:</strong>
                    <button aria-label="btn" type="button" className="btn btn-hour" onClick={() => handleToggleOpenHours(i)}>
                      <span
                        id="collapsible-open"
                        className={`icon-new-down-arrow-icon drop-icon ml-auto mr-4 ${expandOpenHours?.includes(i) ? 'rotated' : ''}`}
                      />
                    </button>

                    <ul id="expand-open" className={expandOpenHours?.includes(i) ? 'opening-hours-ul d-block' : 'opening-hours-ul d-none'}>
                      {vl?.opening_hours?.weekday_text?.map((text, index) => (
                        <li key={index}>{text}</li>
                      ))}
                    </ul>
                  </div>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default GooglePlacesNearMe;
